import { render, staticRenderFns } from "./home-main.vue?vue&type=template&id=5a8f84dd&scoped=true&lang=pug&"
import script from "./home-main.vue?vue&type=script&lang=js&"
export * from "./home-main.vue?vue&type=script&lang=js&"
import style0 from "./home-main.vue?vue&type=style&index=0&id=5a8f84dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f84dd",
  null
  
)

export default component.exports